'use client'

import { useEffect } from 'react'
import HoverGradientButton from '@/components/buttons/HoverGradientButton/HoverGradientButton'
import { logger } from '@lib/logger'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // logger.error captures the PostHog $exception too — calling
    // posthog.captureException here as well would double-count the crash.
    logger.error('error-boundary', error.message, error, { digest: error.digest })
  }, [error])

  return (
    <div id="error-page" className="flex min-h-[60vh] flex-col items-center justify-center gap-6 text-center px-4">
      <h2>Something went wrong</h2>
      <p className="text-black max-w-md">
        We ran into an unexpected error. This has been logged and we&apos;re working on a fix.
        You can try refreshing the page or come back shortly.
      </p>
      <HoverGradientButton onClick={reset}>Try again</HoverGradientButton>
    </div>
  )
}
